import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  Button,
  Paper,
} from '@mui/material';

interface DreamLimitPopoverProps {
  reason: string | null;
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

const DreamLimitPopover: React.FC<DreamLimitPopoverProps> = ({ reason, anchorEl, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  console.log('💬 DreamLimitPopover - Props:', { reason, anchorEl, isOpen: Boolean(reason) });
  
  if (!reason) return null;
  
  let message = '';
  let actionText = '';
  
  if (reason === 'free_limit_reached') {
    message = t('limits.free.message');
    actionText = t('limits.free.action');
  } else if (reason === 'basic_monthly_limit_reached') {
    message = t('limits.basic.message');
    actionText = t('limits.basic.action');
  } else if (reason === 'premium_weekly_limit_reached') {
    message = t('limits.premium.message');
    actionText = t('limits.premium.action');
  }
  
  const handleUpgradeClick = () => {
    onClose();
    navigate('/profile?openPlanModal=true');
  };

  const handleCancelClick = () => {
    onClose();
    navigate('/');
  };
  
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: reason ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fond semi-transparent
      }}
      onClick={(e) => {
        // Fermer uniquement si on clique sur le fond, pas sur le contenu
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 3,
          maxWidth: '90%',
          background: 'var(--Pages-background)',
          borderRadius: '20px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.8)',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="h6" sx={{ color: 'var(--light-green)', fontWeight: 500 }}>
            {t('limits.title')}
          </Typography>
          
          <Typography variant="body1" sx={{ color: 'white', mb: 2 }}>
            {message}
          </Typography>
          
          {/* Conteneur flex pour les boutons qui s'adapte en colonne sur mobile */}
          <Box sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 2,
            width: '100%'
          }}>
            <Button 
              variant="contained"
              onClick={handleUpgradeClick}
              fullWidth
              sx={{
                background: 'var(--button-gradient)',
                color: 'white',
                borderRadius: '25px',
                padding: '12px 20px',
                order: { xs: 1, sm: 2 }, // Ordre inversé sur mobile
                '&:hover': {
                  background: 'linear-gradient(90deg, #58e1c1 0%, #FF3B7C 130%)',
                }
              }}
            >
              {actionText}
            </Button>
            
            <Button 
              variant="outlined"
              onClick={handleCancelClick}
              fullWidth
              sx={{
                color: 'white',
                borderColor: 'rgba(255,255,255,0.3)',
                borderRadius: '25px',
                padding: '12px 20px',
                order: { xs: 2, sm: 1 }, // Ordre inversé sur mobile
                '&:hover': {
                  borderColor: 'white',
                  background: 'rgba(255,255,255,0.1)'
                }
              }}
            >
              {t('common.cancel')}
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default DreamLimitPopover;
